import { GET_PROFILE_METHODS, SET_PROFILE_UPDATED, SET_METHOD_UPDATED, SET_METHOD_DELETED, LOGOUT } from './types';
import api from "../utils/api";
import { isGuid } from "../utils/string";
import { send as sendAlert } from './alert';

export const mine = (uuid = "X") => async (dispatch) => {
    try {

        const res = await api.get(`/methods/me${isGuid(uuid) ? "/"+uuid : ""}`);

        if (res?.data) {
            dispatch({
                type: GET_PROFILE_METHODS,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const customer = () => async (dispatch) => {
    try {
        const res = await api.post(`/stripe/me/customer`, { update: true });
        if ((res?.data?.person) && (res?.data?.success)) {
            dispatch({
                type: SET_PROFILE_UPDATED,
                payload: res.data.person
            });
        }
        return { person: res.data.person };
    } catch (err) {
        await dispatch(sendAlert("Unable to save payment method."));
        return null;
    }
}

export const update = ({ uuid, type, address, last4, expiresDate, name, email, meta, processorId, setupId, agreement, style }) => async (dispatch) => {
    try {
        const res = await api.post("/stripe/me/method", { uuid, type, address, last4, expiresDate, name, email, meta, processorId, setupId, agreement, style });
        if ((res?.data?.method) && (res?.data?.success)) {
            dispatch({
                type: SET_METHOD_UPDATED,
                payload: res.data.method
            });
        }
        if (!res?.data?.success) {
            switch (res?.data?.error?.code) {
                case "expired_card":
                    dispatch(sendAlert("Card rejected by processor (expired).", "warning"));
                    return { success: false, clear: false };      
                case "incorrect_cvc":
                    dispatch(sendAlert("Card rejected by processor (CVC).", "warning"));
                    return { success: false, clear: false };                    
                default:
                    break;
            }
            dispatch(sendAlert("Card rejected by processor.", "error"));
            return { success: false, clear: true };
        }
        return { success: true, method: res.data.method };

    } catch (err) {
        await dispatch(sendAlert("Unable to save payment method."));
        return null;
    }
}

export const patch = ({ uuid, changes }) => async (dispatch) => {
    try {
        await api.patch(`/stripe/me/method/${ uuid }`, changes);
        return { success: true };
    } catch (err) {
        await dispatch(sendAlert("Unable to update payment method."));
        return null;
    }
}

export const destroy = ({ uuid })=> async (dispatch) => {
    try {
        const res = await api.delete(`/stripe/me/method/${ uuid }`);
        if (res?.data?.success) {
            dispatch({
                type: SET_METHOD_DELETED
            });
        }
        return { success: true };

    } catch (err) {
        await dispatch(sendAlert("Unable to delete payment method."));
        return null;
    }
}

export const agreement = () => async (dispatch) => {
    try {
        const res = await api.get(`/stripe/me/method/agreement`);
        return res.data;
    } catch (err) {
        await dispatch(sendAlert("Unable to load payment agreement."));
        return null;
    }
}

export const config = () => async (dispatch) => {
    try {
        const res = await api.get(`/stripe/me/config`);
        return res.data?.stripe || {};
    } catch (err) {
        await dispatch(sendAlert("Unable to load payment processor configuration."));
        return {};
    }
}

export const intent = (agreement = {}) => async (dispatch) => {
    try {
        const res = await api.post(`/stripe/me/intent`, agreement);
        return { success: res.data.success, secret: res.data.secret, error: res.data.error };
    } catch (err) {
        await dispatch(sendAlert("Error while communicating with payment processor."));
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Error while communicating with payment processor."
            }
        };
    }
}
